//hier wird die Anzahl der Artikel im Warenkorb nachgeladen und im Header angezeigt
import { ErrorReporter } from "../common/errorReporter";

export class BasketCountLoader {
    private basketCountElement: HTMLElement | null;

    constructor() {
        this.basketCountElement = document.getElementById("basketcount");
        this.loadBasketCount();
    }

    private async loadBasketCount(): Promise<void> {
        if (!this.basketCountElement) {
            return;
        }

        try {
            const response = await fetch("/warenkorb_count", {
                method: 'POST',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                },
                cache: 'default',
                credentials: 'same-origin'
            });

            if (!response.ok) {
                throw new Error("Network response was not ok.");
            }

            const data = await response.text();

            if (this.basketCountElement) {
                this.basketCountElement.innerHTML = data;
            }

        } catch (error) {
            this.handleError(error);
        }
    }

    private handleError(error: unknown): void {
        const errorReporter = new ErrorReporter();

        if (error instanceof Error) {
            errorReporter.reportError(
                error.message,
                "/warenkorb_count",
                null,
                null,
                error.stack ?? null
            );
        } else {
            errorReporter.reportError(
                typeof error === 'string' ? error : "Error of unknown type",
                "/warenkorb_count",
                null,
                null,
                null
            );
        }
    }

}

